import BaseRequest from "./RequestService";
import { UrlList } from "./UrlList";

export default function GetEvents(callback)
{
  BaseRequest(UrlList.Content_GetEvents,callback);
}